module.exports = __webpack_public_path__ + "img/arc.6d7d797b.png";